export const PRODUCT_TYPE = {
  TRANSLATION: "TRANSLATION",
  SUBSCRIPTION: "SUBSCRIPTION"
}